import { Box, useColorModeValue } from '@chakra-ui/react';

interface VehicleTableHtmlProps {
  html: string;
}

const VehicleTableHtml = ({ html }: VehicleTableHtmlProps) => {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const headerBg = useColorModeValue('gray.100', 'gray.700');

  return (
    <Box
      sx={{
        '& table': {
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: 'sm',
        },
        '& table.RTEBorder': {
          border: '1px solid',
          borderColor: borderColor,
        },
        '& table.RTEBorder td, & table.RTEBorder th': {
          border: '1px solid',
          borderColor: borderColor,
          padding: '8px 12px',
        },
        '& table th': {
          fontWeight: '600',
          bg: headerBg,
        },
        '& table td:first-of-type': {
          fontWeight: '500',
        },
        '& p': {
          mb: 2,
        },
        '& br': {
          display: 'block',
          content: '""',
          mb: 1,
        },
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default VehicleTableHtml;
